(function () {
  'use strict';

  var root = document.querySelector('[data-review-order]');
  if (!root) return;

  var loading = root.querySelector('[data-review-order-loading]');
  var content = root.querySelector('[data-review-order-content]');
  var errorPanel = root.querySelector('[data-review-order-error]');
  var errorMessage = root.querySelector('[data-review-order-error-message]');
  var itemsNode = root.querySelector('[data-review-order-items]');
  var orderNumberNode = root.querySelector('[data-review-order-number]');
  var testBadge = root.querySelector('[data-review-order-test]');
  var reviewForm = root.querySelector('[data-review-order-review-form]');
  var formError = root.querySelector('[data-review-order-form-error]');
  var submitButton = root.querySelector('[data-review-order-submit]');
  var testNote = root.querySelector('[data-review-order-test-note]');
  var successPanel = root.querySelector('[data-review-order-success]');
  var ratings = {};
  var requestData = null;
  var token = new URLSearchParams(window.location.search).get('token');

  function text(value) {
    return String(value == null ? '' : value);
  }

  function element(tag, className, value) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (value) node.textContent = value;
    return node;
  }

  function showError(message) {
    loading.hidden = true;
    content.hidden = true;
    errorMessage.textContent = message;
    errorPanel.hidden = false;
  }

  function productSummary(item) {
    var summary = element('div', 'review-order__product-summary');
    var imageWrap = element('div', 'review-order__image-wrap');

    if (item.imageUrl) {
      var image = document.createElement('img');
      image.className = 'review-order__image';
      image.src = item.imageUrl;
      image.alt = text(item.title);
      image.loading = 'lazy';
      imageWrap.appendChild(image);
    } else {
      imageWrap.appendChild(
        element('span', 'review-order__image-placeholder', 'Product image'),
      );
    }

    var details = element('div', 'review-order__details');
    details.appendChild(element('strong', 'review-order__product', item.title));
    if (item.variantTitle) {
      details.appendChild(
        element('span', 'review-order__variant', item.variantTitle),
      );
    }
    if (item.sku) {
      details.appendChild(element('span', 'review-order__sku', item.sku));
    }

    summary.appendChild(imageWrap);
    summary.appendChild(details);
    return summary;
  }

  function setRating(card, lineItemId, value) {
    ratings[lineItemId] = value;
    card.querySelectorAll('[data-rating]').forEach(function (star) {
      var active = Number(star.getAttribute('data-rating')) <= value;
      star.classList.toggle('is-active', active);
      star.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    card.classList.remove('has-error');
    card.querySelector('[data-review-item-error]').textContent = '';
    formError.textContent = '';
  }

  function renderReviewItem(item, index) {
    var card = element('article', 'review-order__review-item');
    card.setAttribute('data-review-item', '');
    card.setAttribute('data-line-item-id', item.lineItemId);
    card.appendChild(productSummary(item));

    var fields = element('div', 'review-order__fields');
    var rating = document.createElement('fieldset');
    rating.className = 'review-order__rating';
    var legend = element('legend', '', 'Your rating');
    var required = element('span', 'review-order__required', 'Required');
    legend.appendChild(required);
    rating.appendChild(legend);

    var stars = element('div', 'review-order__stars');
    for (var value = 1; value <= 5; value += 1) {
      var star = element('button', 'review-order__star', '★');
      star.type = 'button';
      star.setAttribute('data-rating', value);
      star.setAttribute(
        'aria-label',
        value + (value === 1 ? ' star' : ' stars') + ' for ' + text(item.title),
      );
      star.setAttribute('aria-pressed', 'false');
      star.addEventListener(
        'click',
        (function (selectedValue) {
          return function () {
            setRating(card, item.lineItemId, selectedValue);
          };
        })(value),
      );
      stars.appendChild(star);
    }
    rating.appendChild(stars);

    var bodyId = 'review-order-body-' + index;
    var label = document.createElement('label');
    label.className = 'review-order__label';
    label.htmlFor = bodyId;
    label.appendChild(document.createTextNode('Your review'));
    label.appendChild(
      element('span', 'review-order__required', 'Required'),
    );

    var textarea = document.createElement('textarea');
    textarea.className = 'review-order__textarea';
    textarea.id = bodyId;
    textarea.setAttribute('data-review-body', '');
    textarea.maxLength = 3000;
    textarea.rows = 4;
    textarea.required = true;
    textarea.placeholder = 'What did you like? How did it fit and feel?';
    textarea.addEventListener('input', function () {
      if (textarea.value.trim()) {
        card.classList.remove('has-error');
        card.querySelector('[data-review-item-error]').textContent = '';
        formError.textContent = '';
      }
    });

    var itemError = element('p', 'review-order__item-error');
    itemError.setAttribute('data-review-item-error', '');
    itemError.setAttribute('role', 'alert');

    fields.appendChild(rating);
    fields.appendChild(label);
    fields.appendChild(textarea);
    fields.appendChild(itemError);
    card.appendChild(fields);
    return card;
  }

  function renderRequest(request) {
    requestData = request;
    orderNumberNode.textContent = 'Order #' + text(request.orderNumber);
    testBadge.hidden = request.testMode !== true;
    testNote.hidden = request.testMode !== true;
    itemsNode.replaceChildren();

    (request.items || []).forEach(function (item, index) {
      itemsNode.appendChild(renderReviewItem(item, index));
    });

    loading.hidden = true;
    errorPanel.hidden = true;
    content.hidden = false;
  }

  function collectReviews() {
    var reviews = [];
    var firstInvalid = null;

    (requestData.items || []).forEach(function (item) {
      var card = itemsNode.querySelector(
        '[data-line-item-id="' + CSS.escape(text(item.lineItemId)) + '"]',
      );
      var textarea = card.querySelector('[data-review-body]');
      var itemError = card.querySelector('[data-review-item-error]');
      var messages = [];

      if (!ratings[item.lineItemId]) messages.push('choose a star rating');
      if (!textarea.value.trim()) messages.push('write your review');

      if (messages.length) {
        card.classList.add('has-error');
        itemError.textContent =
          'Required: ' + messages.join(' and ') + '.';
        if (!firstInvalid) {
          firstInvalid =
            !ratings[item.lineItemId]
              ? card.querySelector('[data-rating]')
              : textarea;
        }
        return;
      }

      card.classList.remove('has-error');
      itemError.textContent = '';
      reviews.push({
        lineItemId: item.lineItemId,
        rating: ratings[item.lineItemId],
        body: textarea.value.trim(),
      });
    });

    if (firstInvalid) {
      formError.textContent =
        'Complete the rating and written review for every product.';
      firstInvalid.focus();
      firstInvalid
        .closest('[data-review-item]')
        .scrollIntoView({ behavior: 'smooth', block: 'center' });
      return null;
    }

    return reviews;
  }

  reviewForm.addEventListener('submit', function (event) {
    event.preventDefault();
    formError.textContent = '';
    var reviews = collectReviews();
    if (!reviews) return;

    submitButton.disabled = true;
    submitButton.textContent = 'Submitting all reviews…';

    fetch(root.getAttribute('data-submit-api-url'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'omit',
      body: JSON.stringify({
        token: token,
        reviews: reviews,
      }),
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) {
            throw new Error(payload.error || 'Your reviews could not be saved.');
          }
          return payload;
        });
      })
      .then(function () {
        content.hidden = true;
        successPanel.hidden = false;
        successPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      })
      .catch(function (error) {
        formError.textContent =
          error.message || 'Your reviews could not be saved.';
        submitButton.disabled = false;
        submitButton.textContent = 'Submit all reviews';
      });
  });

  var apiUrl = root.getAttribute('data-api-url');
  if (!token) {
    showError('This review link is missing its secure token.');
    return;
  }

  fetch(apiUrl, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'omit',
    body: JSON.stringify({ token: token }),
  })
    .then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) {
          throw new Error(
            payload.error || 'This review link could not be opened.',
          );
        }
        return payload;
      });
    })
    .then(function (payload) {
      if (
        !payload ||
        !payload.request ||
        !Array.isArray(payload.request.items) ||
        !payload.request.items.length
      ) {
        throw new Error('This order has no products available to review.');
      }
      renderRequest(payload.request);
    })
    .catch(function (error) {
      showError(error.message || 'This review link could not be opened.');
    });
})();
